<template>
	<div>
		<!-- First name -->
		<b-form-group id="first-name-group" label="First name" label-for="first-name" label-class="checkout__label" label-cols-sm="3">
			<b-form-input id="first-name" v-model="address.first_name" type="text" required @change="handleChange" />
		</b-form-group>

		<!-- Last name -->
		<b-form-group id="last-name-group" label="Last name" label-for="last-name" label-class="checkout__label" label-cols-sm="3">
			<b-form-input id="last-name" v-model="address.last_name" type="text" required @change="handleChange" />
		</b-form-group>

		<!-- Company name -->
		<b-form-group id="company-name-group" label="Company name (optional)" label-for="company-name" label-class="checkout__label" label-cols-sm="3">
			<b-form-input id="company-name" v-model="address.company_name" type="text" @change="handleChange" />
		</b-form-group>

		<!-- Country -->
		<b-form-group id="country-group" label="Country" label-for="country" label-class="checkout__label" label-cols-sm="3">
			<b-form-select
				id="country"
				:options="countryCodes"
				value-field="alpha-3"
				text-field="name"
				v-model="address.country"
				required
				@change="handleChange"
			/>
		</b-form-group>

		<!-- Street address -->
		<b-form-group id="address-group" label="Street Address" label-for="address-1" label-class="checkout__label" label-cols-sm="3">
			<b-form-input id="address-1" v-model="address.address" type="text" required @change="handleChange" />
		</b-form-group>

		<!-- Address line 2 -->
		<b-form-group id="address2-group" label="Apt./Unit# (optional)" label-for="address-2" label-class="checkout__label" label-cols-sm="3">
			<b-form-input id="address-2" v-model="address.address2" type="text" @change="handleChange" />
		</b-form-group>

		<!-- City -->
		<b-form-group id="city-group" label="Town / City" label-for="city" label-class="checkout__label" label-cols-sm="3">
			<b-form-input id="city" v-model="address.city" type="text" required @change="handleChange" />
		</b-form-group>

		<!-- State -->
		<b-form-group id="state-group" label="State" label-for="state" label-class="checkout__label" label-cols-sm="3">
			<b-form-select
				v-if="address.country === 'USA'"
				id="state"
				:options="states"
				value-field="abbreviation"
				text-field="name"
				v-model="address.state"
				required
				@change="handleChange"
			/>
			<b-form-select
				v-else-if="address.country === 'CAN'"
				id="state"
				:options="provinces"
				value-field="abbreviation"
				text-field="name"
				v-model="address.state"
				required
				@change="handleChange"
			/>
			<b-form-input v-else id="state" v-model="address.state" type="text" required @change="handleChange" />
		</b-form-group>

		<!-- Zip code -->
		<b-form-group id="zip-code-group" label="Postcode / ZIP" label-for="zip-code" label-class="checkout__label" label-cols-sm="3">
			<b-form-input
				id="zip-code"
				ref="postal"
				v-model="address.postal_code"
				type="text"
				required
				@change="handleChange"
			/>
		</b-form-group>

		<slot name="append" :address="address" :handleChange="handleChange" />

	</div>
</template>

<script>

	import countries from '../../../../resources/data/iso3166-countries-3.json';
	import states from '../../../../resources/data/us-states.json';
	import provinces from '../../../../resources/data/can-provinces.json';

	let requiredProps = [
		'first_name',
		'last_name',
		'country',
		'address',
		'city',
		'state',
		'postal_code'
	];

	export default {
		props: {
			/* Reactive! Object passed in will change in parent! */
			address: {
				required: true,
				validator(address) {
					return requiredProps.every(prop => prop in address);
				}
			},
		},

		data() {
			return {
				countryCodes: countries.filter(c => ['USA', 'CAN'].includes(c['alpha-3'])),
				states: states,
				provinces: provinces
			};
		},

		methods: {
			handleChange(event) {
				this.$emit('update');
				this.checkIfCompleted();
			},

			checkIfCompleted() {
				let completed = true;
				for (let property in requiredProps) {
					let key = requiredProps[property];
					if (this.address[key].length <= 0) {
						completed = false;
					}
				}

				completed ? this.handleCompleted() : null;
			},

			handleCompleted() {
				this.$emit('completed');
			},
		}
	}

</script>

<style lang="scss" scoped>

</style>
